/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ClientAccount;
(function (ClientAccount) {
    let scope;
    (function (scope) {
        scope["CLIENT_ACCOUNT"] = "client_account";
    })(scope = ClientAccount.scope || (ClientAccount.scope = {}));
})(ClientAccount || (ClientAccount = {}));
//# sourceMappingURL=ClientAccount.js.map